module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.editing) ? _c('div', {
    staticClass: "row middle-xs col-xs-12",
    staticStyle: {
      "padding": "10px 0 15px 0"
    }
  }, [_c('pl-button', {
    staticClass: "pl-primary-reverse b",
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("< GO BACK")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1"
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container row",
    class: {
      pt4: _vm.editing
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8 mb4 left-container"
  }, [_c('div', {
    ref: "instructions_container",
    staticClass: "tl instructions-container"
  }, [_c('div', {
    staticClass: "mb2 live-premades-title clickable",
    on: {
      "click": _vm.showCollapseInstructions
    }
  }, [_vm._v("\n          Instructions\n          "), (_vm.show_instructions) ? _c('i', {
    staticClass: "fr fas fa-angle-down"
  }) : _c('i', {
    staticClass: "fr fas fa-angle-right"
  })]), _vm._v(" "), (_vm.show_instructions) ? _c('textbox', {
    staticClass: "h5 relative",
    attrs: {
      "id": "instructions",
      "theme": 'muted-focus',
      "showSubmitButton": false,
      "placeholder": _vm.instructions,
      "fillRemaining": true,
      "focusOnMounted": true
    },
    model: {
      value: (_vm.instructions),
      callback: function($$v) {
        _vm.instructions = $$v
      },
      expression: "instructions"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    ref: "resources_guiding_container",
    staticClass: "mt4 tl resources-guiding-container"
  }, [_c('div', {
    staticClass: "mb2 live-premades-title clickable",
    on: {
      "click": _vm.showCollapseResources
    }
  }, [_vm._v("\n          Resources\n          "), (_vm.show_resources) ? _c('i', {
    staticClass: "fr fas fa-angle-down"
  }) : _c('i', {
    staticClass: "fr fas fa-angle-right"
  })]), _vm._v(" "), (_vm.show_resources) ? _c('div', [_vm._l((_vm.resource_questions), function(resource, index) {
    return _c('div', {
      staticClass: "pl-subheading",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticClass: "row middle-xs"
    }, [_c('div', {
      staticClass: "col-xs-11"
    }, [_vm._v("\n                " + _vm._s(index + 1) + ".\n                "), _c('span', {
      staticClass: "resources-question",
      on: {
        "click": function($event) {
          return _vm.openResourceLink(resource)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(resource.resourceName) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-1 end-xs"
    }, [_c('pl-menu', {
      attrs: {
        "menuSize": 2,
        "direction": "right"
      }
    }, [_c('pl-button', {
      staticClass: "pl-icon",
      staticStyle: {
        "margin": "0"
      },
      attrs: {
        "slot": "menu_trigger"
      },
      slot: "menu_trigger"
    }, [_c('i', {
      staticClass: "fas fa-ellipsis-v"
    })]), _vm._v(" "), _c('ul', {
      attrs: {
        "menu-content": ""
      }
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.editResource(index, resource)
        }
      }
    }, [_c('span', [_vm._v("Edit")])]), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          return _vm.deleteResource(index)
        }
      }
    }, [_c('span', [_vm._v("Delete")])])])], 1)], 1)])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row mt3"
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('pl-input', {
    attrs: {
      "type": "text",
      "labelText": "",
      "maxLength": 255,
      "placeholder": "Resource Name"
    },
    model: {
      value: (_vm.new_resource_name),
      callback: function($$v) {
        _vm.new_resource_name = $$v
      },
      expression: "new_resource_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('pl-input', {
    attrs: {
      "type": "text",
      "labelText": "",
      "maxLength": 255,
      "placeholder": "URL"
    },
    model: {
      value: (_vm.new_resource_url),
      callback: function($$v) {
        _vm.new_resource_url = $$v
      },
      expression: "new_resource_url"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 end-xs"
  }, [(_vm.editing_resource) ? _c('pl-button', {
    staticClass: "pl-primary b",
    staticStyle: {
      "margin": "2px 0",
      "padding": "0",
      "min-width": "60px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveEditResource.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                SAVE\n              ")]) : _c('pl-button', {
    staticClass: "pl-primary pl-icon",
    staticStyle: {
      "margin": "2px 0"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.createNewResource.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-xs-offset-5 error-message"
  }, [_vm._v("\n              " + _vm._s(_vm.error_message) + "\n            ")])])], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mt4 tl resources-guiding-container"
  }, [_c('div', {
    staticClass: "mt4 mb2 live-premades-title clickable",
    on: {
      "click": _vm.showCollapseGuidingQuestions
    }
  }, [_vm._v("\n          Guiding Questions\n          "), (_vm.show_guiding_questions) ? _c('i', {
    staticClass: "fr fas fa-angle-down"
  }) : _c('i', {
    staticClass: "fr fas fa-angle-right"
  })]), _vm._v(" "), (_vm.show_guiding_questions) ? _c('div', [_vm._l((_vm.guiding_questions), function(question, index) {
    return _c('div', {
      staticClass: "pl-subheading",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticClass: "row middle-xs"
    }, [_c('div', {
      staticClass: "col-xs-11"
    }, [_vm._v("\n                " + _vm._s(index + 1) + ". " + _vm._s(question.question) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-1 end-xs"
    }, [_c('pl-menu', {
      attrs: {
        "menuSize": 2,
        "direction": "right"
      }
    }, [_c('pl-button', {
      staticClass: "pl-icon",
      staticStyle: {
        "margin": "0"
      },
      attrs: {
        "slot": "menu_trigger"
      },
      slot: "menu_trigger"
    }, [_c('i', {
      staticClass: "fas fa-ellipsis-v"
    })]), _vm._v(" "), _c('ul', {
      attrs: {
        "menu-content": ""
      }
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.editGuidanceQuestion(index, question)
        }
      }
    }, [_c('span', [_vm._v("Edit")])]), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          return _vm.deleteGuidanceQuestion(index)
        }
      }
    }, [_c('span', [_vm._v("Delete")])])])], 1)], 1)])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row mt3 pb1"
  }, [_c('div', {
    staticClass: "col-xs-11"
  }, [_c('pl-input', {
    attrs: {
      "type": "text",
      "labelText": "",
      "maxLength": 255,
      "placeholder": "Add a question"
    },
    model: {
      value: (_vm.new_guiding_question.question),
      callback: function($$v) {
        _vm.$set(_vm.new_guiding_question, "question", $$v)
      },
      expression: "new_guiding_question.question"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 end-xs"
  }, [(_vm.editing_guiding_question) ? _c('pl-button', {
    staticClass: "pl-primary b",
    staticStyle: {
      "margin": "2px 0",
      "padding": "0",
      "min-width": "60px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveEditGuidanceQuestion.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                SAVE\n              ")]) : _c('pl-button', {
    staticClass: "pl-primary pl-icon",
    staticStyle: {
      "margin": "2px 0"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.createNewGuidingQuestion.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "instructions_container",
    staticClass: "mt4 tl polls-container"
  }, [_c('div', {
    staticClass: "mb1 live-premades-title clickable",
    on: {
      "click": _vm.showCollapsePolls
    }
  }, [_vm._v("\n          Polls\n          "), (_vm.show_polls) ? _c('i', {
    staticClass: "fr fas fa-angle-down"
  }) : _c('i', {
    staticClass: "fr fas fa-angle-right"
  })]), _vm._v(" "), (_vm.show_polls) ? _c('div', [_c('pl-button', {
    staticClass: "pl-white create-poll",
    nativeOn: {
      "click": function($event) {
        return _vm.createNewPoll.apply(null, arguments)
      }
    }
  }, [_c('img', {
    staticClass: "create-new-image",
    attrs: {
      "src": "/static/course_assets/create_new_plus_sign.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', [_vm._v("New")])]), _vm._v(" "), _vm._l((_vm.polls), function(poll, index) {
    return _c('div', {
      staticClass: "pl-subheading"
    }, [_c('div', {
      staticClass: "row middle-xs"
    }, [_c('span', {
      staticClass: "col-xs-11"
    }, [_c('p', {
      staticClass: "poll-btn-text"
    }, [_vm._v("\n                  " + _vm._s(("poll #" + (index + 1))) + " - " + _vm._s(poll.question) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-1 end-xs"
    }, [_c('pl-menu', {
      attrs: {
        "menuSize": 2,
        "direction": "right"
      }
    }, [_c('pl-button', {
      staticClass: "pl-icon",
      staticStyle: {
        "margin": "0"
      },
      attrs: {
        "slot": "menu_trigger"
      },
      slot: "menu_trigger"
    }, [_c('i', {
      staticClass: "fas fa-ellipsis-v"
    })]), _vm._v(" "), _c('ul', {
      attrs: {
        "menu-content": ""
      }
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.selectPoll(poll.id)
        }
      }
    }, [_c('span', [_vm._v("Edit")])]), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          return _vm.deletePoll(poll.id)
        }
      }
    }, [_c('span', [_vm._v("Delete")])])])], 1)], 1)]), _vm._v(" "), _vm._l((poll.answers), function(answer, index) {
      return _c('div', [_c('div', {
        staticClass: "mb1"
      }, [_vm._v("\n                " + _vm._s(String.fromCharCode(65 + index) + ')') + " " + _vm._s(answer) + "\n              ")])])
    }), _vm._v(" "), (index + 1 !== _vm.polls.length) ? _c('div', {
      staticClass: "w-100 bb mt3",
      staticStyle: {
        "border-color": "#979797"
      }
    }) : _vm._e()], 2)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.show_poll) ? [_c(_vm.poll_page, {
    tag: "components",
    staticClass: "show-poll",
    attrs: {
      "selectedPoll": _vm.selected_poll
    },
    on: {
      "selectPoll": function($event) {
        _vm.selected_poll_id = $event
      },
      "closePollDialog": function($event) {
        _vm.show_poll = false
      },
      "pollChanges": _vm.pollChanges
    }
  })] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 mb4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ph3 mt3 premade-fields"
  }, [_c('div', {
    staticClass: "left-xs flex mb3"
  }, [_c('pl-checkbox', {
    model: {
      value: (_vm.is_certified),
      callback: function($$v) {
        _vm.is_certified = $$v
      },
      expression: "is_certified"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Parlay Certified?")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 privacy-save"
  }, [_c('pl-button', {
    staticClass: "f3 pl-primary b",
    nativeOn: {
      "click": function($event) {
        return _vm.saveChanges.apply(null, arguments)
      }
    }
  }, [_vm._v("SAVE CHANGES")]), _vm._v(" "), _c('div', {
    staticClass: "privacy-dropdown"
  }, [_c('pl-menu', {
    attrs: {
      "direction": "right",
      "menuSize": 2
    }
  }, [_c('pl-button', {
    attrs: {
      "slot": "menu_trigger"
    },
    slot: "menu_trigger"
  }, [_c('strong', [_vm._v(_vm._s(_vm.accessibility))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down pa1"
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "menu-content": ""
    }
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.accessibility = 'Public'
      }
    }
  }, [_vm._v("Public")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.accessibility = 'Unlisted'
      }
    }
  }, [_vm._v("Unlisted")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.accessibility = 'Draft'
      }
    }
  }, [_vm._v("Draft")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt3 flex justify-between"
  }, [_c('span', {
    staticClass: "pl-title b black-50 link-button",
    on: {
      "click": _vm.duplicateRoundtable
    }
  }, [_vm._v("DUPLICATE")]), _c('span', {
    staticClass: "pl-title b black-50 link-button",
    on: {
      "click": _vm.deleteRoundtable
    }
  }, [_vm._v("DELETE")])]), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_c('span', [_vm._v("Created:")]), _vm._v("\n          " + _vm._s(_vm.premade_created_date) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_c('span', {
    staticClass: "field-label"
  }, [_vm._v("Title")]), _vm._v(" "), _c('pl-input', {
    staticClass: "mv2 f3",
    nativeOn: {
      "keyup": function($event) {
        return _vm.checkWords.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [(!_vm.uploading_avatar) ? _c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": _vm.get_thumbnail_on_amazon_aws,
      "alt": "No Thumbnail Yet - Click Below to Add One"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.uploading_avatar) ? _c('pl-spinner', {
    staticClass: "x1"
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mt3"
  }, [_c('label', {
    staticClass: "pl-subheading pa1",
    staticStyle: {
      "cursor": "pointer",
      "border": "1px solid black"
    },
    attrs: {
      "for": "file-upload"
    }
  }, [_vm._v("\n            Change or Add Thumbnail ")]), _c('br'), _vm._v(" "), _c('input', {
    ref: "file_to_upload",
    staticClass: "dn",
    attrs: {
      "id": "file-upload",
      "type": "file",
      "accept": "image/webp, image/jpeg, image/png"
    },
    on: {
      "change": _vm.selectFileToUpload
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "field-label mt4 mb0"
  }, [_vm._v("\n          Image source (if image is not your own)\n        ")]), _vm._v(" "), _c('pl-input', {
    staticClass: "mb4 f3",
    model: {
      value: (_vm.image_source),
      callback: function($$v) {
        _vm.image_source = $$v
      },
      expression: "image_source"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "field-label mt4 mb0"
  }, [_vm._v("Author email")]), _vm._v(" "), _c('pl-input', {
    staticClass: "mb4 f3",
    model: {
      value: (_vm.author_email),
      callback: function($$v) {
        _vm.author_email = $$v
      },
      expression: "author_email"
    }
  }), _vm._v(" "), (_vm.isParlayAdmin) ? _c('div', [_c('p', {
    staticClass: "field-label"
  }, [_vm._v("Sensitive Content?")]), _vm._v(" "), _c('toggle-button', {
    staticClass: "ml2",
    attrs: {
      "labels": true,
      "sync": true,
      "color": "#72ccd7"
    },
    model: {
      value: (_vm.disclaimer),
      callback: function($$v) {
        _vm.disclaimer = $$v
      },
      expression: "disclaimer"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_c('span', {
    staticClass: "field-label"
  }, [_vm._v("Subject Areas:")]), _vm._v(" "), _c('multiselect', {
    staticClass: "flex mv2",
    attrs: {
      "options": _vm.subjects,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "preserve-search": true,
      "preselect-first": false,
      "placeholder": "Select subjects",
      "label": "name",
      "track-by": "id"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return _vm._l((values), function(subj, subjIndex) {
          return (values.length && !isOpen) ? _c('span', {
            staticClass: "w-auto multiselect__single"
          }, [_vm._v(_vm._s(subj.name) + _vm._s(subjIndex < values.length - 1 ? ',' : '') + "\n              ")]) : _vm._e()
        })
      }
    }]),
    model: {
      value: (_vm.selected_subjects),
      callback: function($$v) {
        _vm.selected_subjects = $$v
      },
      expression: "selected_subjects"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "field-label mt4 mb0"
  }, [_vm._v("Grades")]), _vm._v(" "), _c('div', {
    staticClass: "grades"
  }, _vm._l((_vm.grade_levels), function(grade, index) {
    return _c('div', {
      key: grade.id,
      staticClass: "dib ml3"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('pl-checkbox', {
      attrs: {
        "value": grade.id
      },
      model: {
        value: (_vm.selected_grade_levels),
        callback: function($$v) {
          _vm.selected_grade_levels = $$v
        },
        expression: "selected_grade_levels"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(grade.grade))])], 1)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_c('span', {
    staticClass: "field-label"
  }, [_vm._v("Tags:")]), _vm._v(" "), _c('multiselect', {
    staticClass: "flex mv2",
    attrs: {
      "tag-placeholder": "Add this as new tag",
      "placeholder": "Search or add a tag",
      "label": "name",
      "track-by": "name",
      "options": _vm.suggestedTags,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag,
      "search-change": function($event) {
        return _vm.searchTags($event)
      }
    },
    model: {
      value: (_vm.selectedTags),
      callback: function($$v) {
        _vm.selectedTags = $$v
      },
      expression: "selectedTags"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_c('span', {
    staticClass: "field-label"
  }, [_vm._v("Skills:")]), _vm._v(" "), _c('multiselect', {
    staticClass: "flex mv2",
    attrs: {
      "placeholder": "Select skills",
      "label": "name",
      "track-by": "name",
      "options": _vm.skills,
      "multiple": true
    },
    model: {
      value: (_vm.selectedSkills),
      callback: function($$v) {
        _vm.selectedSkills = $$v
      },
      expression: "selectedSkills"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_c('span', {
    staticClass: "field-label"
  }, [_vm._v("Description")]), _vm._v(" "), _c('textbox', {
    attrs: {
      "showSubmitButton": false,
      "placeholder": "Write a brief description for this RoundTable here"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_c('span', {
    staticClass: "field-label"
  }, [_vm._v("Publisher Notes")]), _vm._v(" "), _c('textbox', {
    staticClass: "mv2",
    attrs: {
      "showSubmitButton": false,
      "placeholder": "Write in publisher's notes/instructions here"
    },
    model: {
      value: (_vm.publisher_notes),
      callback: function($$v) {
        _vm.publisher_notes = $$v
      },
      expression: "publisher_notes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_c('span', {
    staticClass: "field-label"
  }, [_vm._v("Collections")]), _vm._v(" "), _vm._l((_vm.categories), function(category, index) {
    return _c('div', {
      key: category.id
    }, [_c('pl-checkbox', {
      attrs: {
        "value": category.id
      },
      model: {
        value: (_vm.selected_categories),
        callback: function($$v) {
          _vm.selected_categories = $$v
        },
        expression: "selected_categories"
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "30px"
      }
    }, [_vm._v(_vm._s(category.name))])], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_c('span', {
    staticClass: "field-label"
  }, [_vm._v("PREMADE ID")]), _vm._v(" "), _c('div', {
    staticClass: "mt2"
  }, [_vm._v(_vm._s(_vm.premade.id))])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row middle-xs ph3"
  }, [_c('div', {
    staticClass: "live-rt"
  }, [_c('img', {
    attrs: {
      "width": "28px",
      "height": "28px",
      "src": "/static/live_discussion/live.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml2 f5 b"
  }, [_vm._v(" Verbal Roundtable ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6f349424!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/pages/premades/livePremadeForm.vue
// module id = 1962
// module chunks = 61